"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyFunction = void 0;
// eslint-disable-next-line @typescript-eslint/no-empty-function
var emptyFunction = function () { };
exports.emptyFunction = emptyFunction;
